/// <reference path="../../../../types/quill-shims/index.d.ts" />
import { Component, Inject, OnInit, AfterViewInit, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import imageCompressor from 'quill-image-compress';
import CustomImageResize from 'src/app/modules/libs/quill/quill-custom-image-resize/custom-image-resize';
import { utils } from 'src/app/modules/libs/utils';
import { ImageUploadService } from 'src/app/services/file/image-upload.service';
import * as QuillNamespace from 'quill';
let Quill: any = QuillNamespace;
import ImageResize from 'quill-image-resize-module';
import { ImageDrop } from 'quill-image-drop-module';
// import { ImageResize } from 'quill-image-resize-module';
import QuillMention from 'quill-mention';
import { ResourceType } from 'src/app/common/enumerations/enumerations';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
var Block = Quill.import('blots/block');
Block.tagName = 'P';
Quill.register(Block, true);
var bold = Quill.import('formats/bold');
bold.tagName = 'b';   // Quill uses <strong> by default
Quill.register(bold, true);

Quill.register('modules/customImageResize', CustomImageResize);
Quill.register('modules/imageCompressor', imageCompressor);
// Quill.register('modules/table', QuillTable);

Quill.register('modules/mention', QuillMention);

// const Size = Quill.import('attributors/style/size');
// Size.whitelist = ['14px']; // Add custom sizes
// Quill.register(Size, true);

@Component({
  selector: 'comments-box-edit',
  templateUrl: './comments-box-edit.component.html',
  styleUrls: ['./comments-box-edit.component.scss']
})
export class CommentsBoxEditComponent implements OnInit, AfterViewInit {

  textValue: string;
  serialNo: string;
  formType: string;
  title: string;
  minHeight: string;
  maxHeight: string;
  mentions?: any[];
  strikethroughMentionIds: number[] = [];
  selectedMentions: number[] = [];

  public form!: FormGroup;
  quillCtrl = new FormControl();
  showHTML!: boolean;
  loading!: boolean;
  dialogId!: string;
  resourceTypeEnum = ResourceType;
  thisQuill: any;

  customShielding: boolean = false;

  imageMaxWidth = 300;
  imageSizes!: [{ name: 'Small'; val: 255; }, { name: 'Medium'; val: 400; }, { name: 'Original'; val: 0; }];
  fullScreen = true;
  quillEditorRef: any;
  quillColors = [
    // Row 1: Main ASCC brand colors
    "#212529", "#E04E39", "#D57800", "#EAAA00", "#74AA50", "#006BA6", "#5D4777",
    // Row 2: Light variants + ASCC teal
    "#FFFFFF", "#FF5588", "#FFE9CF", "#FCF5E0", "#CCE8CC", "#E0EDF4", "#007681",
    // Row 3: Medium ASCC theme shades
    "#B1B3B3", "#F0A79C", "#FFD09C", "#F5D580", "#9DC87A", "#4298B5", "#8A6BAA",
    // Row 4: Darker ASCC shades
    "#63666A", "#CB2517", "#DB7F00", "#E19000", "#006100", "#004E8B", "#672E45",
    // Row 5: Darkest shades
    "#444444", "#5C0000", "#663D00", "#666600", "#003700", "#003C7B", "#3D1466",
  ];

  quillConfig = {
    mention: {
      allowedChars: /^[A-Za-z0-9_.ÅÄÖåäö]*$/,
      dataAttributes: ['id', 'value', 'isGroup', 'groupName', 'parentResourceType', 'childResourceType', 'shared', 'sharedWith', 'color', 'title', 'windchillLinks'],
      mentionDenotationChars: ["@"],
      showDenotationChar: false, // Hide the "@" symbol in the mention dropdown
      blotName: 'styled-mention',
      source: (searchTerm: string, renderList: (matches: any[], searchTerm: any) => void) => {
        if (!this.mentions) return;

        let filteredMentions = this.mentions;

        if (searchTerm.length > 0) {
          filteredMentions = this.mentions.filter(item =>
            item.value.toLowerCase().includes(searchTerm.toLowerCase())
          );
        }

        // Create group headers and organize items under them
        let matchesWithHeaders: any[] = [];
        let currentGroup: string | undefined;

        filteredMentions.forEach(item => {
          if (item.isGroup) {
            // Add group header
            if (currentGroup !== item.value) {
              matchesWithHeaders.push({
                id: `group-${item.value}`,
                value: item.value,
                isGroup: true,
                disabled: true
              });
              currentGroup = item.value;
            }
          } else {
            const isAlreadySelected = this.selectedMentions.includes(item.id);
            const isUnapproved = this.strikethroughMentionIds.includes(item.id);
            // Add shielding item
            matchesWithHeaders.push({
              id: item.id,
              value: item.value,
              groupName: item.groupName,
              parentResourceType: item.parentResourceType,
              childResourceType: item.childResourceType,
              shared: item.shared,
              sharedWith: item.sharedWith,
              title: item.title ?? '',
              isAlreadySelected, // Store this property but do not use `disabled`
              isUnapproved,
              // Stringify here so the value reaching the DOM is a plain string
              windchillLinks: item.windchillLinks && item.windchillLinks.length > 0
                ? JSON.stringify(item.windchillLinks)
                : ''
            });
          }
        });

        window.setTimeout(() => {
          renderList(matchesWithHeaders, searchTerm);
          setTimeout(() => this.observeDropdown(), 100); // Call with 'this'
        }, 500);
      },

      renderItem: (data: {
        isGroup?: boolean;
        value: string;
        parentResourceType?: number;
        childResourceType?: number;
        shared?: boolean;
        sharedWith?: any[];
        disabled?: boolean;
        color?: string;
        matTooltip?: string;
        title?: string;
        isAlreadySelected?: boolean;
        isUnapproved?: boolean;
      }) => {
        const div = document.createElement("div");
        div.innerText = data.value;

        // Apply different styles for group headers and regular items
        if (data.isGroup) {
          div.style.fontWeight = "bold"; // Highlight group names
          div.style.color = "#0366d6";
          div.style.padding = "4px 10px";
          div.style.fontSize = "14px";
          div.style.borderBottom = "1px solid #ddd";
          div.style.pointerEvents = "none";
          div.style.opacity = "0.6";
          div.style.userSelect = "none"; // Prevent text selection
        } else {
          div.style.paddingLeft = "12px"; // Indent shielding items
          div.style.fontSize = "14px"; // Smaller font size for shielding items
          div.classList.add('mention-list-item-medium');
          div.title = data.title ?? '';

          // Apply conditional styling based on shielding properties
          if (data.isAlreadySelected || data.isUnapproved) {
            div.style.color = "gray";
            // Unapproved TOCAs remain visible for existing descriptions but cannot be inserted again.
            div.setAttribute('data-disabled', 'true');
          }
          else if (data.parentResourceType === this.resourceTypeEnum.Shutter ? data.shared : (data.sharedWith?.length ?? 0) > 0) {
            div.style.color = "red";
            data.color = "red";
          } else if (data.childResourceType && data.childResourceType > 99) {
            div.style.color = "darkorange";
            data.color = "darkorange";
          }
          else {
            div.style.color = "#333";
            data.color = "#333";
          }
        }

        return div;
      },
      onSelect: (item: any, insertItem: any) => {
        if (item.isGroup || item.isUnapproved) return;
        insertItem(item);
      }
    },
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
        [{ script: 'sub' }, { script: 'super' }],      // superscript/subscript
        [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
        ['table'], // Add the table option to the toolbar
        ['link', 'image', 'video'],
        ['clean'],
      ],
    },
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          handler: (range: any, context: any) => {
            return true;
          }
        }
      }
    },
    imageDrop: true,
    imageResize: true,
    customImageResize: true,
    imageCompressor: {
      quality: 0.3, // default
      maxWidth: this.imageMaxWidth, // default
      imageType: 'image/*', // default
      debug: true
    },
  };

  defaultSelect!: string;

  constructor(
    private service: ImageUploadService,
    public dialog: MatDialogRef<CommentsBoxEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private elem: ElementRef,
    private cdRef: ChangeDetectorRef) {
    this.textValue = data.textValue;
    this.serialNo = data.serialNo;
    this.formType = data.formType;
    this.title = data.title;
    this.minHeight = data.minHeight;
    this.maxHeight = data.maxHeight;
    this.mentions = data.mentions;
    this.selectedMentions = data.selectedMentions;
    this.strikethroughMentionIds = data.strikethroughMentionIds ?? [];
  }

  ngOnInit(): void {
    this.buildForm();
  }

  ngAfterViewInit() {
    this.maximize();

    this.quillEditorRef = this.quillCtrl.valueChanges.subscribe(() => {
      const editor = document.querySelector('.ql-editor'); // Get the Quill editor content
      if (!editor) return;

      // Extract mention IDs from the editor
      const mentionsInEditor: number[] = [];
      editor.querySelectorAll('span[data-id]').forEach((mention) => {
        const id = Number(mention.getAttribute('data-id'));
        if (!isNaN(id)) {
          mentionsInEditor.push(id);
        }
      });
      this.selectedMentions = mentionsInEditor;
    });
  }

  buildForm() {
    this.form = new FormGroup({
      quillCrtl: this.quillCtrl
    });
    this.quillCtrl.setValue(this.textValue);
  }

  // Observe the dropdown for changes and apply pointer-events to disabled items
  observeDropdown() {
    const dropdown = document.querySelector('.ql-mention-list-container');
    if (!dropdown) return;

    const applyStyles = () => {
      dropdown.querySelectorAll('div[data-disabled="true"]').forEach(div => {
        const parentLi = div.closest('li');
        if (parentLi) {
          parentLi.style.pointerEvents = 'none';
          parentLi.style.opacity = '0.5';
        }
      });
    };

    // Apply styles initially in case items are already present
    applyStyles();

    // Observe changes and re-apply styles when necessary
    const observer = new MutationObserver(() => {
      applyStyles();
    });

    observer.observe(dropdown, { childList: true, subtree: true });
  }

  created(quill: any) {
    $('.ql-container').css('min-height', this.minHeight);
    $('.ql-container').css('max-height', this.maxHeight);
    $('.ql-editor').css('max-height', this.maxHeight);
    const dialogs = $('.mat-mdc-dialog-container');
    this.dialogId = dialogs[dialogs.length - 1].id;
    this.changed();
    quill.focus();
    setTimeout(() => quill.setSelection(quill.getLength(), 0));
    this.thisQuill = quill;
    // Apply approval-driven formatting after Quill has rendered the saved mention blots.
    setTimeout(() => this.decorateStrikethroughMentions());
  }

  mouseOut() {
    // utils.removeExistingCustomContainers();
  }

  async save() {
    const editor = this.thisQuill;
    this.removeDynamicStrikethrough();
    const raw = editor.root.innerHTML;
    const html = raw
      .replace(/<\/p>\s*<p[^>]*>/gi, '<br>')
      .replace(/<\/?p[^>]*>/gi, '');
    const updatedTextValue = await this.uploadImages(html);
    this.data.selectedMentions = this.selectedMentions;
    this.data.textValue = updatedTextValue;
    this.loading = false;
    this.dialog.close(this.data);
  }

  /**
   * Applies a temporary strikeout to rendered mentions that are no longer approved.
   */
  private decorateStrikethroughMentions(): void {
    const editor = this.thisQuill?.root as HTMLElement | undefined;
    editor?.querySelectorAll<HTMLElement>('span[data-id]').forEach(mention => {
      // Global classes override nested legacy Quill styles without rewriting saved formatting.
      mention.classList.add('mention-chip-medium');
      const mentionId = Number(mention.getAttribute('data-id'));
      if (this.strikethroughMentionIds.includes(mentionId)) {
        mention.dataset['dynamicStrikethrough'] = 'true';
        mention.classList.add('unapproved-toca-mention');
        mention.dataset['unapprovedTooltip'] = 'This TOCA is unapproved.';
      }
    });
  }

  /**
   * Removes approval-driven formatting before the editor HTML is saved.
   */
  private removeDynamicStrikethrough(): void {
    const editor = this.thisQuill?.root as HTMLElement | undefined;
    editor?.querySelectorAll<HTMLElement>('[data-dynamic-strikethrough="true"]').forEach(mention => {
      mention.classList.remove('unapproved-toca-mention');
      delete mention.dataset['dynamicStrikethrough'];
      delete mention.dataset['unapprovedTooltip'];
    });
  }

  cancel() {
    this.dialog.close();
  }

  applyCustom() {
    const selected = this.thisQuill.getSelection().length;
    // If no selection toggle on or off
    if (!selected) {
      this.customShielding = !this.customShielding;
    }

    if (selected || this.customShielding) {
      this.thisQuill.format('color', 'blue');
      this.thisQuill.format('background', '#d3e1eb');
      this.thisQuill.format('bold', true);
    }
    else {
      this.thisQuill.format('color', false);
      this.thisQuill.format('background', false);
      this.thisQuill.format('bold', false);
    }
  }

  async uploadImages(textValue: string) {
    const text = await this.service.uploadImagesToServer(textValue, '/' + this.formType.toString()?.trim() + '/' + this.serialNo + '/Comments/');
    return text;
  }

  isShowHTML() {
    this.showHTML = !this.showHTML;
    this.cdRef.detectChanges();
    this.changed();
  }

  changed() {
    // const editorHeight = $('.edit-container').height() ?? 0;
    const windowHeight = $('#' + this.dialogId).height() ?? 0;
    $('.ql-container').height(windowHeight - 50);
    $('.html-textarea').height(windowHeight - 70);
    // if (editorHeight > windowHeight - 22) {
    //   $('#' + this.dialogId).height(editorHeight - 22);
    // }
  }

  maximize() {
    this.fullScreen = true;
    this.dialog.addPanelClass('maximized');
  }

  restore() {
    this.fullScreen = false;
    this.dialog.removePanelClass('maximized');
  }

  imageSizeSelected(e: { label: any; value: any; }) {
    this.elem.nativeElement.querySelector('.imageSizes .ql-picker-label').innerHTML
      = e.label + this.defaultSelect;
    this.imageMaxWidth = e.value;
    this.quillConfig.imageCompressor.maxWidth = this.imageMaxWidth;
    Quill.register('modules/imageCompressor', imageCompressor);
  }

  addTable(e: { clipboard: { dangerouslyPasteHTML: (arg0: string) => void; }; }) {
    var tableHtml = '<table><tr><td>Cell 1</td><td>Cell 2</td></tr><tr><td>Cell 3</td><td>Cell 4</td></tr></table>';
    e.clipboard.dangerouslyPasteHTML(tableHtml);
  }

}

// #region Mention style
const MentionBlot = Quill.import("blots/mention");

class StyledMentionBlot extends MentionBlot {
  static render(data: any) {
    const element = document.createElement("span");
    element.innerText = data.value;
    element.style.color = data.color || '#333';
    element.classList.add('mention', 'mention-chip-medium');

    const hasTitle = data.title && data.title.length > 0;
    const hasLinks = typeof data.windchillLinks === 'string' && data.windchillLinks.length > 2;

    if (hasTitle) {
      element.setAttribute('data-title', data.title);
    }

    if (hasLinks) {
      element.setAttribute('data-windchill-links', data.windchillLinks);
    }

    if (hasTitle || hasLinks) {
      element.style.cursor = 'pointer';
      element.style.textDecoration = 'underline';
      // element.style.textDecorationStyle = 'dotted';
    }

    return element;
  }
}
StyledMentionBlot['blotName'] = "styled-mention";
StyledMentionBlot['tagName'] = "span";

Quill.register(StyledMentionBlot, true);
// #endregion
